import React from "react";
import { NavLink, Outlet } from "react-router-dom";
import { LayoutDashboard, FileText, Heart, User, ShieldCheck, Car, Wallet } from "lucide-react";
import Header from "../components/sections/header";
import FooterComponent from "../components/sections/Footer/FooterComponent";
import { Page } from "../components/ui/Page";
import useAuth from "../hooks/useAuth";

// `customerOnly` items are hidden from admins (admins don't buy/trade).
const navItems = [
    { to: "/account/dashboard", label: "Dashboard", icon: LayoutDashboard, customerOnly: true },
    { to: "/account/activate", label: "Activate Trading", icon: Wallet, customerOnly: true },
    { to: "/account/request-quote", label: "Request a Car", icon: Car, customerOnly: true },
    { to: "/account/quotes", label: "My Requests", icon: FileText, customerOnly: true },
    { to: "/account/saved", label: "Saved Cars", icon: Heart, customerOnly: true },
    { to: "/account/profile", label: "Profile", icon: User, customerOnly: false },
];

const AccountAppLayout: React.FC = () => {
    const { authState } = useAuth();

    const linkClass = ({ isActive }: { isActive: boolean }) =>
        "flex items-center gap-3 px-4 py-2.5 rounded-lg text-sm font-medium transition-colors " +
        (isActive ? "bg-purple-600 text-white" : "text-gray-600 hover:bg-gray-100");

    return (
        <Page>
            <Header />
            <div className='px-4 md:px-8 lg:px-32 py-6 grid grid-cols-1 lg:grid-cols-4 gap-8 min-h-[60vh]'>
                <aside className='lg:col-span-1'>
                    <nav className='flex lg:flex-col gap-2 overflow-x-auto'>
                        {navItems
                            .filter((n) => !(n.customerOnly && authState.isAdmin))
                            .map(({ to, label, icon: Icon }) => (
                                <NavLink key={to} to={to} className={linkClass} end>
                                    <Icon size={18} />
                                    <span>{label}</span>
                                </NavLink>
                            ))}
                        {authState.isAdmin && (
                            <NavLink to='/account/admin' className={linkClass}>
                                <ShieldCheck size={18} />
                                <span>Admin</span>
                            </NavLink>
                        )}
                    </nav>
                </aside>
                <main className='lg:col-span-3'>
                    <Outlet />
                </main>
            </div>
            <FooterComponent />
        </Page>
    );
};

export default AccountAppLayout;
